import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { BrowserLocalstorage } from '@/app/store'
import { routes } from '@Config/config'

export const useCheckAuth = () => {
    const navigate = useNavigate()
    const accessToken: string | null = BrowserLocalstorage.getToken()

    const { AUTH } = routes

    useEffect(() => {
        if (!accessToken) {
            navigate(AUTH)
        }
    }, [accessToken, AUTH, navigate])

    return !!accessToken
}
